import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "./api";
import {handleResponseStatus} from "./utils";

const initialAuthState = {
    user: {},
    selectedRole: null,
    token: null,
    isValid: null,
    loginStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    fetchUserStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    logoutStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    error: null
};

export const login = createAsyncThunk('auth/login', async (initialState) => {
    try {
        const response = await api.post('/auth/login', initialState);
        return {...response}
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

export const logout = createAsyncThunk('auth/logout', async () => {
    try {
        const response = await api.get('/auth/logout');
        return {...response}
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});


export const fetchAuthUser = createAsyncThunk('auth/fetchAuthUser', async () => {
    try {
        const response = await api.get('/auth/me');
        return {...response}
    } catch (error) {
        if (error.response) return error.response;
        throw error
    }
});





const authSlice = createSlice({
    name: "auth",
    initialState: initialAuthState,
    reducers: {
        setUserRole: (state, action) => {
            state.selectedRole = action.payload;  // update Redux state
            localStorage.setItem('selectedRole', JSON.stringify(action.payload));
        },
        getUserRole: (state) => {
            const selectedRole = JSON.parse(localStorage.getItem('selectedRole'));
            const token = localStorage.getItem('authToken');
            if (selectedRole && token) {
                state.selectedRole = selectedRole; // update Redux state
            }
            else {
                state.selectedRole = null; // update Redux state
            }
        },
        fetchToken: (state) => {
            const token = localStorage.getItem('authToken');
            state.token = token;
            state.isValid = token != null;
            if(token === null){
                state.selectedRole = null;
                state.fetchUserStatus = 'idle';
            }
        }
    },
    extraReducers(builder) {
        builder
            // login
            .addCase(login.pending, (state) => {
                state.loginStatus = 'loading';
            })
            .addCase(login.fulfilled, (state, action) => {
                if (action.payload.status === 200) {
                    state.loginStatus = 'success';
                    state.isValid = true;
                    state.token = action.payload.data.accessToken;
                    localStorage.setItem("authToken", action.payload.data.accessToken);

                } else {
                    state.loginStatus = 'failed';
                    state.error = action.payload.data.message;
                }
            })
            .addCase(login.rejected, (state, action) => {
                state.loginStatus = 'failed';
                state.error = action.error.message;
            })

            // logout
            .addCase(logout.pending, (state) => {
                state.logoutStatus = 'loading';
            })
            .addCase(logout.fulfilled, (state, action) => {
                if (action.payload.status === 200) {
                    state.logoutStatus = 'success';
                    state.fetchUserStatus = 'idle';
                    localStorage.removeItem('authToken');
                    localStorage.removeItem('selectedRole');
                    state.isValid = false;
                    state.token = null;
                    state.selectedRole = null;
                } else {
                    state.loginStatus = 'failed';
                    state.error = action.payload.data.message;
                }
            })
            .addCase(logout.rejected, (state, action) => {
                state.loginStatus = 'failed';
                state.error = action.error.message;
            })


            .addCase(fetchAuthUser.pending, (state) => {
                state.fetchUserStatus = 'loading';
            })
            .addCase(fetchAuthUser.fulfilled, (state, action) => {
                const { fetchUserStatus, error } = handleResponseStatus(action.payload, 'fetchUserStatus');
                state.user = fetchUserStatus === "success" ? action.payload.data.user : state.user;
                state.fetchUserStatus = fetchUserStatus;
                state.error = error;
            })
            .addCase(fetchAuthUser.rejected, (state, action) => {
                state.fetchUserStatus = 'failed';
                state.error = action.error.message;
            })
    }

});

export const { setUserRole, getUserRole, fetchToken } = authSlice.actions;
export default authSlice.reducer;


